import { schemaDefaultDocuments } from '../../../../api/defaults/links'
import React from 'react'
import { IDocumentDefault, TSchemaDocument } from '../../../../api/types'
import { elWFull, FormLayout, InputGroup, InputWrapFull } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { FileState, InputFile } from '@reapitform/common-ui'

interface IDocumentFormProps {
  formId: string
  defaultValues?: IDocumentDefault
  onSubmit: (data: TSchemaDocument) => void
}

export const DocumentForm: React.FC<IDocumentFormProps> = ({ defaultValues, onSubmit, formId }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<TSchemaDocument>({
    defaultValues: {
      formType: 'GeneralTenancyAgreement',
      ...defaultValues,
    },
    resolver: yupResolver(schemaDefaultDocuments),
  })

  const handleOnSubmit = (data: TSchemaDocument) => {
    onSubmit(data)
  }

  const handleFileChange = (data?: FileState) => {
    if (!data)
      return setValue('document', {
        fileId: '',
        fileName: '',
        fileSize: 0,
        status: '',
      })

    setValue('document', {
      fileId: data.fileId || '',
      fileName: data.fileName,
      fileSize: data.fileSize,
      status: data.internalStatus || '',
    })
  }

  return (
    <ErrorBoundary>
      <form id={formId} onSubmit={handleSubmit(handleOnSubmit)} className={cx(elWFull)}>
        <FormLayout hasMargin>
          <InputWrapFull>
            <InputGroup
              label="Form *"
              placeholder="Contact Name"
              {...register('formType')}
              errorMessage={errors.formType?.message}
              disabled
            />
          </InputWrapFull>
          <InputWrapFull>
            <InputFile
              onChange={handleFileChange}
              label="Document"
              required={true}
              errorMessage={errors.document?.message || errors.document?.fileId?.message}
              acceptedFileType="agreement/attachment"
              maximumFileSize="4 mb"
            />
          </InputWrapFull>
        </FormLayout>
      </form>
    </ErrorBoundary>
  )
}
